<template>
  <li v-if="!editing" @click="editing = true" class="p-2 not-editing">
    <slot></slot>
    
    <div class="delete-icon" @click="$emit('remove')">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
      </svg>
    </div>
  </li>
  <li v-else>
    <slot name="edit-item-content">
      <div class="d-flex justify-content-between">
        <input
          v-model="newValue"
          
          ref="input"
          class="p-2"

          @keydown="keydown"
        >
        <button v-if="newValue.length && newValue !== value"
          class="btn btn-light flex-shrink-0"
          @click="saveItem"
        >
          Voeg item toe
        </button>
        <span v-else></span>
      </div>
    </slot>
  </li>
</template>

<script>

export default {
  props: {
    value: String,
  },
  data() {
    return {
      newValue: this.value || "",
      editing: false,
    }
  },
  methods: {
    saveItem() {
      this.$emit("save", this.newValue)
      this.editing = false
    },
    keydown({key}) {
      if (key === "Enter") this.saveItem()
    },
  },
  watch: {
    editing(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.input) this.$refs.input.focus()
        })
      }
    },
  },
}

</script>

<style scoped>

.delete-icon {
  position: absolute;
  right: 0px;
  top: 0px;
  margin-right: 3px;
  margin-top: 3px;
}

input {
  flex-basis: 100%;
  flex-grow: 1;
}

.not-editing {
  padding-right: 40px !important;
}

</style>
